import { render, staticRenderFns } from "./SendMsg.vue?vue&type=template&id=3f596471&scoped=true&"
import script from "./SendMsg.vue?vue&type=script&lang=ts&"
export * from "./SendMsg.vue?vue&type=script&lang=ts&"
import style0 from "./SendMsg.vue?vue&type=style&index=0&id=3f596471&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f596471",
  null
  
)

export default component.exports